import * as TYPES from './types';
import { searchAgents, getAgentInfo, handleAgent } from '../../../common/agents';
import util from '@/common/util';
export default {
    [TYPES.SET_AGENTS](payload) {
        this.agents = [...payload];
    },
    [TYPES.SET_TOTAL](payload) {
        this.total = payload;
    },
    [TYPES.SET_TOTAL_COUNT](payload) {
        this.totalCount = payload;
    },
    [TYPES.SET_ALL_TOTAL](payload) {
        this.allTotal = payload;
    },

    async [TYPES.FETCH_AGENTS](
        {
            agentIds,
            pageSize = 24,
            pageNum,
            searchParams = {},
            customAgents = [],
            queryAll,
            showAllAgents,
            autoSort = false,
            useSwiperApiParams = false,
            initFlag = false,
            _t
        }
    ) {
        if (agentIds || queryAll || showAllAgents) {
            let params = {
                agentIds,
                pageSize,
                pageNum,
                showAllAgents,
                autoSort,
                useSwiperApiParams,
                includeCalendarLink: true,
                ...searchParams
            }
            if (_t) {
                params._t = _t
            }
            let res = await searchAgents.call(this, params);
            let { dataList, pages, total } = res.data;
            dataList = dataList.map(a => {
                let customAgent = customAgents.find(
                    c => c.id == a.id || c.fullName == a.fullName
                );
                if (customAgent) {
                    Object.assign(a, customAgent);
                }
                if (a.externalUrl && !a.externalUrl.includes('//')) {
                    a.externalUrl = 'https://' + a.externalUrl;
                }
                return a;
            });

            this[TYPES.SET_AGENTS](dataList);
            this[TYPES.SET_TOTAL](pages);
            if (initFlag || util.inCms) {
                this[TYPES.SET_ALL_TOTAL](pages);
                this[TYPES.SET_TOTAL_COUNT](total);
            }
        } else {
            this[TYPES.SET_AGENTS]([]);
            this[TYPES.SET_TOTAL](0);
        }
    },
    async [TYPES.FETCH_AGENT_INFO](agentId, useExternalUrl) {
        let hasAgent = this.agents.find(agent => agent.id === agentId);
        if (hasAgent) {
            return hasAgent;
        }
        let agentInfo = await getAgentInfo.call(this, { agentId });
        agentInfo && this.agents.push(handleAgent(agentInfo, { useExternalUrl }));
        return agentInfo;
    }
};
